<template>
  <div :class="dynamicClasses" class="column">
    <div :class="dynamicClassesInner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nna-col',
  props: {
    align: {
      type: String, 
      default: "center",
    },   
    separator: {
      type: Boolean, 
      default: true,       
    },          
  },
  computed: {
    dynamicClassesInner () {
      return {
        [''] : this.align === 'none',
        ['column__inner'] : this.align === 'center',        
        ['column__inner column__inner--right'] : this.align === 'right',
        ['column__inner column__inner--left'] : this.align === 'left'
      }
    },
    dynamicClasses () {
      return {
        ['column--separator'] : this.separator,
        ['column--center'] : this.align === 'center'
      }
    }    
  }
}
</script>
<style scoped>
.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  height: 60px;
  position: relative;
}

.column--center {
  align-items: center;
  justify-content: center;
}

.column--separator {
  border-bottom: 1px solid #ddd;
}
.column__inner {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.column__inner--right {
  right: 0;
}
.column__inner--left {
  left: 0;
}
</style>




// WEBPACK FOOTER //
// ../nonameapp-common-modules/src/components/Col/Col.vue